import { EmptyCircle, FilledCircle } from 'assests/GmsIcons';
import React from 'react';
import { TCBMRule } from '../DefineModel/model';
import { TAttributeChoice } from 'types/Pages/ProductDelta';


type TMatrixTableProps = {
    leftSideAttributeValues: TAttributeChoice[];
    rightSideAttributeValues: TAttributeChoice[];
    cbmRule: TCBMRule;
    setCbmRule: React.Dispatch<React.SetStateAction<TCBMRule>>;
}

const MatrixTable = ({leftSideAttributeValues, rightSideAttributeValues, cbmRule, setCbmRule}: TMatrixTableProps) => {

    
    const handleCellClick = (row: any, column: any) => {

        const columnIndex = rightSideAttributeValues.findIndex(pramCol => (pramCol.av_id ??  pramCol.id) === column.id);
        const rowIndex = leftSideAttributeValues.findIndex(paramRow => (paramRow.av_id ?? paramRow.id) === row.id);
        if (rowIndex !== -1 && columnIndex !== -1) {
            // setCbmRule((prev) => {
            //     const cbm:any = prev?.cbm ?? cbmRule.cbm
            //     const propName = rightSideAttributeValues[columnIndex]?.av_value ?? rightSideAttributeValues[columnIndex]?.value
            //     if(cbm[`${propName}`]) cbm[`${propName}`][rowIndex]= cbm[`${propName}`][rowIndex] === 0 ? 1: 0
            //     // console.log("🚀 ~ file: MatrixTable.tsx:39 ~ MatrixTable ~ CBM:", cbm);
            //     return cbmRule
            // }
            // )
            setCbmRule((prev) => {
                const updatedCbm = JSON.parse(JSON.stringify(prev.cbm || {}));
                
                const propName = rightSideAttributeValues[columnIndex]?.av_value ?? 
                                rightSideAttributeValues[columnIndex]?.value ?? 
                                "unknown"; 
                if (!updatedCbm[propName]) {
                    updatedCbm[propName] = Array(leftSideAttributeValues.length).fill(0);
                }
                updatedCbm[propName][rowIndex] = updatedCbm[propName][rowIndex] === 0 ? 1 : 0;
                return { ...prev, cbm: updatedCbm };
            });
        }
    };

    const isCellSelected = (rowId: string, columnId: string) => {
        const rowIndex = leftSideAttributeValues.findIndex(paramRow => paramRow.id === rowId);
        const columnIndex = rightSideAttributeValues.findIndex(paramCol => paramCol.id === columnId);
        const cbm:any = cbmRule?.cbm ?? cbmRule.cbm
        const propName = rightSideAttributeValues[columnIndex]?.value
        //  const isSelected = cbm && cbm[`${propName}`] && cbm[`${propName}`][rowIndex] === 0 ? false:true
        const isSelected = cbm && cbm[`${propName}`] && cbm[`${propName}`][rowIndex] === 1 ? true : false;
        return isSelected;
    };

    return (
        <div className="tw-mt-4 tw-overflow-scroll tw-border">
            <table className="tw-table-auto tw-border tw-border-collapse tw-w-auto">
                <thead>
                <tr>
                    <th></th>
                    {rightSideAttributeValues.map((column) => (
                    <th className="tw-border tw-w-auto tw-p-2 tw-text-[#090A42] tw-text-sm tw-font-normal" key={column.id}>
                        {column.value}
                    </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {leftSideAttributeValues.map((row) => (
                    <tr className="tw-border tw-w-auto" key={row.id}>
                    <td className="tw-p-2 tw-sticky tw-left-0 tw-bg-white">
                        {row.value ?? ''}</td>
                    {rightSideAttributeValues.map((column) => (
                        <td className="tw-border tw-bg-shades-of-grey-10" key={column.id}>
                        <label data-testid="rules-matrixtable-label-1"
                            className="tw-flex tw-items-center tw-justify-center"
                            onClick={() => handleCellClick((row), (column))}
                        >
                            {isCellSelected((row.id as string), (column.id as string)) ? (
                            <span role="img" aria-label="Filled Circle">
                                <FilledCircle />
                            </span>
                            ) : (
                            <span role="img" aria-label="Empty Circle">
                                <EmptyCircle />
                            </span>
                            )}
                        </label>
                        </td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export default MatrixTable;